import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getActionTypeList = store => store[NAME].actionTypeList;
export const getMomentList = store => store[NAME].momentList;
export const getMaterialsList = store => store[NAME].materialsList;
export const getMaterialTreeData = store => store[NAME].materialTreeData;
export const getTrainingList = store => store[NAME].trainingList;